/**
 * @generated SignedSource<<835e9bda758b4dc34c912eae976d086d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SidebarEventCard_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "visualization",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startsAt",
              "storageKey": null
            }
          ],
          "type": "EventVisualization",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "84a0f924959d599ba36f6df84c866c13";

module.exports = node;
